// src/pages/admin/AdminDoctorView.js
import React, { useEffect, useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Header from '../../components/Header';
import AdminSidebar from './AdminSidebar';
import Footer from '../../components/Footer';
import LMPillarTable from '../../components/LMPillarTable';
import './AdminDoctorView.css';
import { useNavigate } from "react-router-dom"; // ⬅️ ADDED for redirect

const pillars = [
  { label: "Overall", collection: "lm_overall" },
  { label: "Nutrition", collection: "lm_nutrition" },
  { label: "Recipes", collection: "lm_recipes" },
  { label: "Exercise", collection: "lm_exercise" }
];


export default function AdminDoctorView() {
  const email = localStorage.getItem("userEmail"); // ⬅️ ADDED get stored email
  const navigate = useNavigate(); // ⬅️ ADDED navigate for redirection
  // Admin-only checks are handled globally by AdminRoute wrapper
  return (
    <>
      <Header />
      <div className="admin-layout">
        <div className="admin-body">
          <AdminSidebar />
          <div className="admin-content">
            <h2>Doctor View - LM Pillars</h2>
            <Tabs>
              <TabList>
                {pillars.map(p => (
                  <Tab key={p.label}>{p.label}</Tab>
                ))}
              </TabList>

              {pillars.map(p => (
                <TabPanel key={p.collection}>
                  <LMPillarTable collection={p.collection} />
                </TabPanel>
              ))}
            </Tabs>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
